export function capitalizeFirstLetter(text: string) {
	let result = '';
	const parts = text.split(' ');
	for (let i = 0; i < parts.length; i++) {
		let part = parts[i];
		if (part.length > 0) {
			part = part[0].toUpperCase() + part.substring(1);
			result += (result !== '' ? ' ' : '') + part;
		}
	}

	return result;
}